import r from "./restArguments.js";
import t from "./difference.js";
var e = r(function (r, e) {
  return t(r, e);
});
export { e as default };